<!--
    描述：系统登录页
    时间：2020.3.13
    created by ws
-->
<template>
  <div class="login-layout">
    <div class="login-header">
      <div class="login-logo">
        <img class="logo-img" src="@/assets/images/logo.png" alt="" />
      </div>
    </div>

    <!-- 中间 banner -->
    <div class="login-bannner">
      <div class="login-box">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          autocomplete="on"
          label-position="left"
          label-width="0"
        >
          <div class="title-container ">
            <div class="title ">能工社运营管理</div>
          </div>

          <!-- 用户名 -->
          <el-form-item prop="username">
            <el-row>
              <el-col :span="3" class="text-center">
                <span class="svg-container pdl13">
                  <svg-icon icon-class="user" />
                </span>
              </el-col>
              <el-col :span="20">
                <el-input
                  ref="username"
                  v-model="loginForm.username"
                  placeholder="请输入用户名"
                  name="username"
                  type="text"
                  clearable
                  tabindex="1"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>

          <!-- 密码 -->
          <el-tooltip
            v-model="capsTooltip"
            content="大写已开启"
            placement="right"
            manual
          >
            <el-form-item prop="password">
              <el-row>
                <el-col :span="3" class="text-center">
                  <span class="svg-container pdl13">
                    <svg-icon icon-class="password" />
                  </span>
                </el-col>
                <el-col :span="18">
                  <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="请输入密码"
                    name="password"
                    tabindex="2"
                    autocomplete="on"
                    @keyup.native="checkCapslock"
                    @blur="capsTooltip = false"
                    @keyup.enter.native="handleLogin"
                  />
                </el-col>
                <el-col :span="3" >
                  <span class="show-pwd" @click="showPwd">
                    <svg-icon
                      :icon-class="
                        passwordType === 'password' ? 'eye' : 'eye-open'
                      "
                    />
                  </span>
                </el-col>
              </el-row>
            </el-form-item>
          </el-tooltip>

          <el-button
            :loading="btnLoading"
            class="sure"
            @click.native.prevent="handleLogin"
            >登录</el-button
          >
        </el-form>
      </div>
    </div>

    <!-- 底部信息文字 -->
    <div class="login-footer">
      <p class="footer-info">
        <span>工作时间：7*24小时</span>
        <span class="ml20">联系电话：400-800-6335</span>
        <span class="ml20">技术支持：安徽本末数据科技有限公司</span>
      </p>
      <p class="footer-info">
        <a class="mr20" href="http://www.beian.gov.cn/"
          ><i class=""></i>皖公网安备 34019102000906号</a
        ><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">ICP证：皖ICP备18000629号-4</a>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          {
            required: true,
            trigger: "blur",
            message: "请输入用户名",
          },
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            message: "请输入密码",
            // validator: validatePassword
          },
        ],
      },
      passwordType: "password",
      capsTooltip: false, // 大写开启提示
      btnLoading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
    };
  },
  mounted() {
    // 初始聚焦
    if (this.loginForm.username === "") {
      this.$refs.username.focus();
    } else if (this.loginForm.password === "") {
      this.$refs.password.focus();
    }
  },
  methods: {
    ...mapActions("user", ["loginIn"]),
    // 检查是否开启了大写
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },

    // 是否显示密码(改变密码框 type)
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },

    // 登录
    handleLogin() {
      this.btnLoading = true;

      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // console.log(this.loginForm)

          // 登录接口
          this.loginIn({
            username: this.loginForm.username,
            password: this.loginForm.password,
          })
            .then(() => {
              this.$router.push({
                path: "/main",
              });
              this.btnLoading = false;
            })
            .catch(() => {
              this.btnLoading = false;
            });
        } else {
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
          // this.$message.error('')
          return false;
        }
      });
    },

    // 获取其它参数
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
  },

  computed: {
    // 路由列表
    routerList() {
      return this.$router.options.routes;
    },
  },
};
</script>

<style lang="less">
.login-layout {
  height: 100%;

  .login-logo {
    width: 100px;
    height: 40px;
    margin-right: 10px;
    display: inline-block;
    vertical-align: middle;
  }

  .login-header {
    height: 100px;
    background-color: #fff;

    .login-logo {
      padding-left: 360px;
      padding-top: 25px;
    }
    img {

      width: 450px;
    }

  }

  .login-bannner {
    width: 100%;
    height: 650px;
    background: url("../../assets/images/login_bg.jpg");
    position: relative;
  }

  .login-box {
    border-radius: 8px;
    background: #fff;
    padding-left: 70px;
    padding-top: 93px;
    width: 460px;
    height: 460px;
    position: absolute;
    top: 95px;
    right: 385px;

    .title {
      font-family: "Source Han Sans SC";
      margin-bottom: 35px;
      font-size: 26px;
      color: #000;
    }
    .el-form-item {
      height: 43px;
      width: 320px;
      margin-bottom: 25px;
      background: #f2f4fa;
      border-radius: 5px;
    }

    .el-form-item_error {
      color: #fb3131;
    }
    .el-form-item--small .el-form-item__content,
    .el-form-item--small .el-form-item__label {
      line-height: 43px;
    }
    .el-input__inner {
      height: 43px;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0;
      caret-color: #333 !important;
    }
    .show-pwd {
      cursor: pointer;
      user-select: none;
    }
    .sure {
      height: 43px;
      background: #0c7cf6;
      color: #fff;
      width: 320px;
      font-size: 16px;
    }
  }
  .login-box .el-input__inner:-webkit-autofill,
  .login-box .el-input__inner:-webkit-autofill:hover,
  .login-box .el-input__inner:-webkit-autofill:focus,
  .login-box .el-input__inner:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #f2f4fa inset !important; /* 使用父容器背景色覆盖 */
    -webkit-text-fill-color: #333 !important; /* 设置文字颜色 */
    transition: background-color 9999s ease-in-out 0s; /* 禁用颜色过渡动画 */
  }

  /* 普通输入框状态保持一致 */
  .login-box .el-form-item .el-input__inner {
    background-color: #f2f4fa !important;
  }

  .login-footer {
    height: calc(100% - 750px);
    padding-top: 20px;
    background-color: #fff;
    .footer-info {
      text-align: center;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }
}
.pdl13 {
  padding-left: 13px;
}
</style>
